import { Grid } from "@mui/material";
import LabeledValue from "@/components/LabeledValue";
import {
  GROUP_FIELDS_LABEL,
  GROUP_FIELDS_SECTION,
  GROUP_UNCONFIGURED_VALUE,
} from "../group-visit-constant";
import { GroupDetail } from "../group-visit-types";
import { formatMinToRun } from "../group-visit-utils";
import DetailCard from "./DetailCard";

export type SessionCapacityCardProps = {
  /** Chosen group; placeholders show until one is picked. */
  group?: GroupDetail;
};

/** Read-only session duration, Max Capacity and Min to run of the chosen group. */
const SessionCapacityCard = ({ group }: SessionCapacityCardProps) => (
  <DetailCard title={GROUP_FIELDS_SECTION.CAPACITY}>
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          md: 4,
        }}
      >
        <LabeledValue
          label={GROUP_FIELDS_LABEL.sessionDuration}
          value={group?.sessionDurationMinutes || GROUP_UNCONFIGURED_VALUE}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 4,
        }}
      >
        <LabeledValue
          label={GROUP_FIELDS_LABEL.maxCapacity}
          value={formatMinToRun(group?.maxCapacity)}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 4,
        }}
      >
        <LabeledValue
          label={GROUP_FIELDS_LABEL.minToRun}
          value={formatMinToRun(group?.minToRun)}
        />
      </Grid>
    </Grid>
  </DetailCard>
);

export default SessionCapacityCard;
